import { render, staticRenderFns } from "./dataTitle.vue?vue&type=template&id=6a1c980a&scoped=true&"
import script from "./dataTitle.vue?vue&type=script&lang=ts&"
export * from "./dataTitle.vue?vue&type=script&lang=ts&"
import style0 from "./dataTitle.vue?vue&type=style&index=0&id=6a1c980a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1c980a",
  null
  
)

export default component.exports